import { ConfirmationService, createConfirmResult } from "./confirmation.service";

export const confirmDeleteWithMessege = async (message) => {
  const confirmationResult = await ConfirmationService.createP({
    width: 376,
    body: `${message}`
  });
  return confirmationResult;
}

export const confirmDelete = async (itemName = 'Arbitrary Item Name', itemIdentifier = '', assurance = `Are you sure you want to delete the`) => {
  const confirmationResult = await ConfirmationService.createP({
    width: 376,
    body: `${assurance}${itemName ? ' ' + itemName : ''}${itemIdentifier ? ' - ' + itemIdentifier : ''}?`
  });
  return confirmationResult;
}
export const confirmMessage = async (message = '',body="") => {
  const confirmationResult = await ConfirmationService.createP({
    subject: message,
    body:body
  });
  return confirmationResult;
}
export const confirmOK = async (message = '') => {
  const confirmationResult = await ConfirmationService.createP({
    subject: message,
    width: 376,
    results: [{ text: "OK", classes: "v1", value: "ok" }]
  });
  return confirmationResult;
}
export const confirmError = async (message = '') => {
  const confirmationResult = await ConfirmationService.createP({
    subject: message,
    subjectClass: 'ut-text-error',
    results: [
      createConfirmResult({
        value: "ok",
        text: "OK",
        classes: ["v1 s7"],
      }),
    ],
  });
  return confirmationResult;
}
export const confirmWarning = async (message = '') => {
  const confirmationResult = await ConfirmationService.createP({
    subject: message
  });
  return confirmationResult;
}

export const okMessage = async (message = '', subject = 'Warning') => {
  const confirmationResult = await ConfirmationService.createP({
    subject: subject,
    body: message,
    results: [
      createConfirmResult({
        value: "ok",
        text: "OK",
        classes: ["v1 s7"],
      }),
    ],
  });
  return confirmationResult;
}

window.confirmMessage=confirmMessage;